module.exports = __webpack_public_path__ + "p6_img2.jpg?ed8148b0a2cddd28719730f5f17d895b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img2.jpg
// module id = 117
// module chunks = 0